<template>
    <rd-text :usebyTable="false">{{ row.nickname }}</rd-text>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
    mixins:[mixin],
    data(){
        return{

        }
    }

}
</script>